import styles from 'css/src/components/app/format-picker.module.scss';

import React, { useCallback, useState } from 'react';
import type { AspectRatio } from '@lumen5/luminary';

import FormatOption from 'js/src/components/app/editor-tabs/FormatOption';
import { SecondaryButton } from 'js/src/components/common/ui/Button';
import Modal from 'js/src/components/common/ui/modal';

interface AspectRatioModalProps {
    isOpen: boolean;
    onClose: () => void;
    onApply: (aspectRatio: AspectRatio) => void;
    initialAspectRatio: AspectRatio;
    availableAspectRatios: AspectRatio[];
    title?: string;
    description?: string;
    header?: React.ReactNode;
}

export const AspectRatioModal: React.FC<AspectRatioModalProps> = ({
    isOpen,
    onClose,
    onApply,
    initialAspectRatio,
    availableAspectRatios,
    title = 'Select format',
    description = "Select the format you'd like to use for your video.",
    header,
}) => {
    const [selectedAspectRatio, setSelectedAspectRatio] = useState<AspectRatio>(initialAspectRatio);

    const handleAspectRatioSelect = useCallback((aspectRatio: AspectRatio) => {
        setSelectedAspectRatio(aspectRatio);
    }, []);

    const handleApply = useCallback(() => {
        onApply(selectedAspectRatio);
    }, [onApply, selectedAspectRatio]);

    return (
        <Modal
            showing={isOpen}
            onHidden={onClose}
            title={title}
            footer={
                <>
                    <SecondaryButton text="Cancel" onClick={onClose} />
                    <SecondaryButton text="Apply" onClick={handleApply} />
                </>
            }
        >
            <div className="p-l5-16">
                {header}

                <div className="mb-l5-12 color-grey-700">
                    <p className="mb-l5-8">{description}</p>
                </div>

                <div className={styles['format-picker']}>
                    <div className={styles['option-container']}>
                        {availableAspectRatios.map((aspectRatio: AspectRatio) => {
                            return (
                                <FormatOption
                                    key={aspectRatio as string}
                                    aspectRatio={aspectRatio}
                                    selected={selectedAspectRatio === aspectRatio}
                                    onClick={handleAspectRatioSelect}
                                />
                            );
                        })}
                    </div>
                </div>
            </div>
        </Modal>
    );
};
